import type { ButtonProps } from "@mui/material/Button";
import { createContext, type ReactNode } from "react";

export type ConfirmOptions = {
  confirmText?: string;
  cancelText?: string;
  confirmColor?: ButtonProps["color"];
  confirmIcon?: ReactNode;
  onConfirm?: () => Promise<void>;
};

export type ConfirmFunction = {
  (question: string, options?: ConfirmOptions): Promise<boolean>;
  (
    question: string,
    description: string,
    options?: ConfirmOptions
  ): Promise<boolean>;
};

export const ConfirmContext = createContext<ConfirmFunction | null>(null);
